import {
    Arbitrary,
    boolean,
    constantFrom,
    record,
    string
} from 'fast-check';
import { DatiqPanelPopupPosition } from './datiq-panel-popup.enum';
import { IDatiqPanelPopup } from './datiq-panel-popup.interface';

export const generatePanelPopup: () => Arbitrary<IDatiqPanelPopup> = () => {
    return record(
        {
            id: string(),
            icon: string(),
            label: string(),
            closeIcon: string(),
            closeOnEsc: boolean(),
            closeOnOutsideClick: boolean(),
            opened: boolean(),
            disabled: boolean(),
            position: constantFrom(
                DatiqPanelPopupPosition.LeftBottom,
                DatiqPanelPopupPosition.RightBottom,
                DatiqPanelPopupPosition.UnderLabel,
                DatiqPanelPopupPosition.Unknown
            ),
        },
        {
            requiredKeys: ['id', 'icon'],
        }
    );
};
